/***
 * Created on 2023/10/26
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import TextInput from "../common/form/text_input";
import {useOnChange} from "common/Hook";
import Captcha from "../common/captcha";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {apiGet, apiPost, executeGrecaptcha} from "../../service/api";
import {useCountdown} from "../../hook/countdown";
import {getErrorMessage} from 'common/ServiceCommon';
import {useLocation} from "react-router-dom";


function ForgetPasswordPhone({}) {
    const { t } = useTranslation();
    const {values, onChange, setValues} = useOnChange({code: ''});
    const {seconds, setSeconds} = useCountdown(0);
    const [errorMessage, setErrorMessage] = useState();
    const queryClient = useQueryClient()
    const location = useLocation();
    const {qid, country_code} = location.state;

    const {data, isSuccess} = useQuery({
        queryKey: ['get_countdown'],
        queryFn: async () => await apiGet('/ajax/countdown')
    });

    const resendMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/send_mobile_code', data),
        onSuccess: data => {
            queryClient.invalidateQueries({queryKey: ['get_countdown']});
        },
        onError: (error, variables, context) => {}
    });

    const verifyMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/verify_mobile', data),
        onSuccess: data => {
            window.location.href = `/resetpassword/${data?.forget_password_token}`
        },
        onError: (error, variables, context) => {
            setErrorMessage(getErrorMessage(t, error.cause?.code))
        }
    });

    const onResend = async (e) => {
        await executeGrecaptcha('', () => {
            const data = {}
            resendMutation.mutate(data)
        });

    }

    const onVerify = async (e) => {
        setErrorMessage(null);
        await executeGrecaptcha('', () => {
            const data = {
                code: values.code
            }
            verifyMutation.mutate(data)
        });

    }

    useEffect(() => {
        if (data && isSuccess) {
            const now = new Date().getTime();
            const value = Math.round((now - data?.countdown) / 1000) || 0;
            setSeconds(value > 60 ? 0 : 60 - value);
        }
    }, [data, isSuccess]);

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Forgot Password@')}</div>
            <div className="common-page-body">
                <p>{t('@The verification code was sent to@')}
                    <span className="font-semibold pl-4 pr-4">({country_code}) {qid}</span>
                </p>
                <p>{t('@Please check your SMS and enter the verification code in the box below@')}</p>
                <div className="common-form-group">
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            <TextInput className="input--must-fill" noWrap={true} name='code' inputMode={'numeric'}
                                       value={values.code} onChange={onChange} required={true} maxLength={6} pattern="\d{6}"/>
                            <button className="q-btn q-btn-default" onClick={onResend} disabled={seconds > 0}>{t('@Resend@')} {(seconds > 0) ? seconds : ""}</button>
                        </div>
                    </div>
                    {errorMessage && <p className="text-error mt-10">{errorMessage}</p>}
                </div>

                <Captcha value={values.captcha} inputChangeHandler={onChange} resetValue={() => setValues(prev => ({...prev, captcha: ''}))}/>

            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={onVerify}>{t('@Verify@')}</button>
                </div>
            </div>
        </section>
    );
}

export default ForgetPasswordPhone;